(function () {
  function init() {
    var wrap = document.querySelector('[data-store-only-ids]');
    if (!wrap) return;
    var sid = wrap.getAttribute('data-section-id');
    var root = document.getElementById('product-' + sid);
    var notice = document.getElementById('store-only-notice-' + sid);
    var data = document.getElementById('store-only-variants-' + sid);
    if (!root || !notice || !data) return;
    var ids = wrap.getAttribute('data-store-only-ids').split(',').filter(Boolean);
    var variants = JSON.parse(data.textContent);

    function currentValues() {
      return Array.prototype.map.call(root.querySelectorAll('[data-js-product-variant]'), function (el) {
        var radio = el.querySelector('input[type=radio]:checked');
        if (radio) return radio.value;
        var select = el.querySelector('select');
        return select ? select.value : null;
      });
    }

    function update() {
      var vals = currentValues();
      if (!vals.length) return;
      var match = null;
      variants.forEach(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        if (vals.every(function (val, i) { return val === opts[i]; })) match = v;
      });
      var storeOnly = !!(match && ids.indexOf(String(match.id)) > -1);
      notice.style.display = storeOnly ? 'block' : 'none';
      wrap.style.display = storeOnly ? 'none' : '';
    }

    root.addEventListener('change', function () { setTimeout(update, 0); });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();